import { useOpenWebVoice } from '#pplx/frontend/apps/ask/multimodal/voice/launcher/useOpenWebVoice.js';
export function useOpenVoiceToVoiceModal() {
    return useOpenWebVoice();
}
//# sourceMappingURL=useOpenVoiceToVoiceModal.js.map